module.exports = __webpack_public_path__ + "static/img/html.3f45115d.svg";